import Button from "@/components/ui/button";
import { useLocation } from "react-router-dom";

export function EnfinityPrimaryBtn({
  name,
  children,
  className = "",
  variant,
  onClick,
  disable,
  type = "button",
  asChild = false,
  noBorder = false,
  noHoverAnimation = false,
  ...props
}) {
  const isFullWidth = className.includes('w-full');
  const button = (
    <Button
      className={`bg-[#292929] hover:bg-[#292929] text-white px-6 py-5 rounded-3xl transition-all duration-300 ease-out font-medium w-full ${noBorder ? 'hover:-translate-y-1 hover:shadow-xl' : ''} ${className}`}
      type={type}
      onClick={onClick}
      disabled={disable}
      asChild={asChild}
      {...props}
    >
      {name || children}
    </Button>
  );

  if (noBorder) {
    return button;
  }

  return (
    <div 
      className={`rounded-3xl p-[0.5px] ${isFullWidth ? 'block w-full' : 'inline-block'} ${noHoverAnimation ? '' : 'transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl'}`}
      style={{
        background: 'linear-gradient(to bottom, #808080 0%, rgba(255, 255, 255, 0) 100%)'
      }}
    >
      {button}
    </div>
  );
}

export function EnfinitySecondaryBtn({
  name,
  children,
  className = "",
  onClick,
  disable,
  type = "button",
  asChild = false,
  ...props
}) {
  return (
    <Button
      className={`bg-white transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl  text-[#121212] hover:bg-gray-50 py-5 px-6 rounded-3xl font-medium min-w-36 ${className} `}
      type={type}
      onClick={onClick}
      disabled={disable}
      asChild={asChild}
      {...props}
    >
      {name || children}
    </Button>
  );
}
